import React from "react"
import { Box, Button, Typography } from "@material-ui/core"
import { EnumDialogs, useDialogStore } from "services/store/dialog-store"
import { useStyles } from "./historico-pedidos-error-styles"
import { EnumModals, useModalStore } from "services/store/modal-store"
import { PedidoVazioIcon } from "components/icons/pedido-vazio-icon"

type THistoricoPedidosErrorProps = {
    textPrimary: string
    textSecondary?: string
    isLogin?: boolean
}

export const HistoricoPedidosError = ({ textPrimary, textSecondary, isLogin }: THistoricoPedidosErrorProps) => {
    const classes = useStyles()
    const { openCloseDialog } = useDialogStore(state => state)
    const { openCloseModal } = useModalStore(state => state)

    const abrirLogin = () => {
        openCloseModal(EnumModals.HistoricoPedidos, false)
        openCloseDialog(EnumDialogs.Autenticar, true)
    }
    return (
        <Box className={classes.container}>
            <div className={classes.content}>
                <PedidoVazioIcon tipo="GERAL" />
                <Typography variant="h6" color="textPrimary" gutterBottom>
                    {textPrimary}
                </Typography>
                {textSecondary && (
                    <Typography variant="body1" color="textSecondary">
                        {textSecondary}
                    </Typography>
                )}
                {isLogin && (
                    <Box mt={3}>
                        <Button onClick={abrirLogin} color="primary" variant="contained" size="large">
                            Entrar na Conta
                        </Button>
                    </Box>
                )}
            </div>
        </Box>
    )
}